import styled from 'styled-components';

export const TooltipWrapper = styled.div`
    .tooltip {
        z-index: 9999;
        padding: 8px 12px;
    }
`;
